var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"input",attrs:{"type":"file","accept":"image/*","id":"input"},on:{"change":function($event){return _vm.inputListener($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }